import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const data = {
  profile: {},
  profileLoadingStatus: '',
  maritalStatus: {},
  maritalStatusLoadingStatus: '',
  address: {},
  addressLoadingStatus: '',
  complianceStatus: {},
  complianceStatusLoadingStatus: '',
  amountOwedItems: [],
  amountOwedLoadingStatus: '',
  amountOwedYears: [],
  levy: {},
  claimedDependents: {},
  claimedDependentsLoadingStatus: '',
  countiesOfState: [],
};

export default {
  state: data,
  getters,
  mutations,
  actions,
};
